<template>
    <div :class="basket.amount && parseInt(basket.amount) !==0 ? 'item' :'item empty_basket'">

        <div class="main_description" v-if="restaurant">
            <img :src="product.photo" alt="pizza">
            <div class="link_row">
                <a href="#" class="rest_name">{{restaurant.name}}</a>
                <p class="delivery_time">{{restaurant.delivery_time}} мин</p>
            </div>
        </div>
        <div class="main_description" v-else>
            <div class="image_box">
              <img :src="product.photo" alt="pizza" class="single">
              <div class="dish_overlay">
                <div class="dish_info">
                  <div class="post_time" v-if="product.delivery_time">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/delivery_green.svg"/>
                    <span>{{product.delivery_time}} мин</span>
                  </div>
                  <div class="info_icons" v-if="Object.keys(product.icons).length">
                    <img v-if="product.icons.baby" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/babyfood.svg" />
                    <img v-if="product.icons.hot" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/spicyfood.svg" />
                    <img v-if="product.icons.good" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/healthyfood.svg" />
                    <img v-if="product.icons.vegan" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/vegfood.svg" />
                  </div>
                </div>
                <div class="dish_sale" v-if="product.stock">
                  <h2>АКЦИЯ!</h2>
                </div>
              </div>
            </div>
        </div>
        <div class="title">
            <h4>{{product.name}}</h4>
            <span>{{product.restaurant_name}}</span>
            <a v-if="product.stocks" class="stock">Акция</a>
        </div>
        <div class="text_row">
            <p v-if="product.desc !== '1'">
                {{product.desc}}
            </p>
            <p v-if="product.desc !== '1'" class="description_popup">
                {{product.desc}}
            </p>
        </div>
        <!--p class="pizza_weight">Выберите вес:</p>
        <div class="custom-select-wrapper">
            <div class="custom-select">
                <div class="custom-select_trigger"><span><strong>429 руб /</strong><small>30 см</small></span>
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/select_arrow.png" alt="">
                    <div class="arrow"></div>
                </div>
                <div class="custom-options">
                    <span class="custom-option" data-value="379"><strong>379 руб /</strong><small>25 см</small></span>
                    <span class="custom-option selected" data-value="429"><strong>429 руб /</strong><small>30 см</small></span>
                    <span class="custom-option" data-value="509"><strong>509 руб /</strong><small>35 см</small></span>
                    <span class="custom-option" data-value="589"><strong>589 руб /</strong><small>40 см</small></span>
                </div>
            </div>
        </div-->
        <div class="prise_row">
            <p><strong><!--span class="old_price">480 руб</span--> {{product.price}}</strong> / {{product.weight}} {{product.weight_type}}</p>
            <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
        </div>

    </div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'item',
  props: ['product', 'restaurant', 'basket'],
  methods: {
    putInBasket (id) {
      if (this.$root.geo.address && this.$root.geo.lat2 && this.$root.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.$root.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
        })
      } else this.$root.modals = 'selectCity'
    },
    plusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.$root.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/plus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    minusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.$root.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    }
  }
}
</script>

<style scoped>
.item .main_description img.single {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/item.vue